export default __webpack_public_path__ + "static/image-thumbnail-b948f98b5b9068bfd4888fcc0162a611.png";